import React from 'react'
import { DefaultClientProfiles } from '../constants'
import { Paper, Typography, Grid, Box, Button } from '@material-ui/core'
import { useHistory } from 'react-router'

const ConsultingContentMap: { [key: string]: string } = {
    'A': '亲子关系及孩子教育问题',
    'B': '婚姻关系及家庭关系问题',
    'C': '我个人的心理、情绪或者执行力问题',
    'D': '我被诊断或怀疑我是成人ADHD',
    'E': '我孩子确诊是ADHD（多动症）',
    'F': '我怀疑我孩子是ADHD（多动症）'
}

type ClientProfilesViewProps = {
    profiles: ClientProfiles,
    hideDetailButtton?: boolean
}

const ClientProfilesView = ({ profiles,hideDetailButtton }: ClientProfilesViewProps = { profiles: DefaultClientProfiles }) => {
    const history = useHistory()

    const isChoose = (...c: string[]) => {
        return c.includes(profiles.consulting_content)
    }

    const isTrue = (c: string) => {
        return +c === 1
    }



    const toInput = {
        is_have_children: isChoose('C') && ['已婚', '已婚分居', '离异'].includes(profiles.marital_status),
        marital_status: isChoose('A', 'B', 'C', 'D'),
        spouse_age: isChoose('A', 'B') || (isChoose('D') && ['已婚'].includes(profiles.marital_status)),
        children_count: isChoose('A', 'B', 'E', 'F'),
        children: isChoose('A', 'B', 'E', 'F'),
        disagnosed_adhd: isChoose('D'),
        disagnosed_date: (isChoose('D') && isTrue(profiles.disagnosed_adhd)) || isChoose('E'),
        is_taking_medicine: isChoose('E') || (isChoose('D') && isTrue(profiles.disagnosed_adhd)),
        medicine_name: (isChoose('E') || isChoose('D')) && isTrue(profiles.is_taking_medicine),
        is_stop_taking_medicine: isChoose('E') && isTrue(profiles.is_taking_medicine),
        reason_of_stop_taking_medicine: isChoose('E') && isTrue(profiles.is_taking_medicine) && isTrue(profiles.is_stop_taking_medicine)
    }

    return <Paper style={{ padding: '16px', boxSizing: 'border-box' }}>
        <Box display="flex" alignItems="center">
            <Typography>来访者基本信息</Typography>
            {!hideDetailButtton && <Button onClick={()=> history.push(`/coach/client/${profiles.user_id}`)} style={{marginLeft: '10px'}} size="small">查看详细信息</Button>}
        </Box>
        <Grid container spacing={2} style={{ marginTop: '12px' }}>
            <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">姓名：</Typography>{profiles.name}</Grid>
            <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">年龄：</Typography>{profiles.age ? `${profiles.age}岁` : ''}</Grid>
            <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">性别：</Typography>{profiles.gender}</Grid>
            <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">手机号：</Typography>{profiles.mobile}</Grid>
            <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">邮箱：</Typography>{profiles.email}</Grid>
            <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">微信：</Typography>{profiles.wechat}</Grid>
            <Grid item xs={6}>
                <Typography variant="subtitle2" display="inline" color="textSecondary">来访者想咨询或求助的内容：</Typography>
                <Typography display="inline">{ConsultingContentMap[profiles.consulting_content]}</Typography>
            </Grid>

            {
                toInput.marital_status &&
                <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">婚姻状态：</Typography>{profiles.marital_status}</Grid>
            }

            {
                toInput.spouse_age &&
                <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">配偶年龄：</Typography>{profiles.spouse_age ? `${profiles.spouse_age}岁` : ''}</Grid>
            }

            {
                toInput.disagnosed_adhd &&
                <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">是否被确诊为ADHD：</Typography>{profiles.disagnosed_adhd ? '是' : '否'}</Grid>
            }
            {
                toInput.disagnosed_date &&
                <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">被诊断的时间：</Typography>{profiles.disagnosed_date}</Grid>
            }

            {
                toInput.is_have_children && <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">是否有孩子：</Typography>{+profiles.is_have_children === 1 ? '有' : '无'}</Grid>
            }

            {
                toInput.children && profiles.children &&
                <Grid item xs={3}>
                    <Typography display="inline" variant="subtitle2" color="textSecondary">孩子：</Typography>
                    {profiles.children && JSON.parse(profiles.children).map((child: { age: string, gender: string }) => {
                        if (child.age && child.gender) {
                            return `${child.gender}(${child.age}岁)  `
                        }
                    })}
                </Grid>
            }

            {
                toInput.is_taking_medicine &&
                <React.Fragment>
                    <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">是否服用药物：</Typography>{+profiles.is_taking_medicine === 1 ? `是(${profiles.medicine_name})` : '否'}</Grid>
                    {toInput.is_stop_taking_medicine && <Grid item xs={3}><Typography display="inline" variant="subtitle2" color="textSecondary">是否停药：</Typography>{+profiles.is_stop_taking_medicine === 1 ? `是(${profiles.reason_of_stop_taking_medicine})` : '否'}</Grid>}
                </React.Fragment>
            }
            <Grid item xs={12}><Typography display="inline" variant="subtitle2" color="textSecondary">主要问题描述：</Typography>{profiles.problem_description}</Grid>
        </Grid>
    </Paper>
}

export default ClientProfilesView